// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__F8XRq","inputWrap":"Table_inputWrap__14Im2","col":"Table_col__1hYLG","bmiTooltip":"Table_bmiTooltip__3cQ3E"};